export const HOURS_INFORMATION = [
  {
    id: 1,
    date: 'Sunday 12 noon - 8 pm'
  },
  {
    id: 2,
    date: 'Monday 11 am - 8 pm'
  },
  {
    id: 3,
    date: 'Tuesday 11 am - 8 pm'
  },
  {
    id: 4,
    date: 'Wednesday 11 am - 9 pm'
  },
  {
    id: 5,
    date: 'Thusrday 11 am - 9 pm'
  },
  {
    id: 6,
    date: 'Friday 11 am - 9 pm'
  },
  {
    id: 7,
    date: 'Saturday 11 am - 9 pm'
  },
];